export const USER = 'USER';
export const ADMIN = 'ADMIN';
export const MODERATOR = 'MODERATOR';